export enum LocalStorageKeys {
    DEBUG_MODE = `debugMode`,
    DISPLAY_INSTALLATION_INSTRUCTIONS = `displayedInstallationInstructions`,
    MEMBERSHIP_PLAN = `membershipPlan`,
    PARTNER = `partner`,
    VISITED_PARTNER_PAGE = `visitedPartnerPage`,
    CLIENT_ORDER_ID_KEY = `clientOrderId`,
    MYINFO_REASON = `myinfoReason`,
    REFERRAL_CODE = `referralCode`,
    SUBSCRIPTION_GIFT_REDEMPTION_CODE = `subscriptionGiftRedemptionCode`,
    USER_JUST_BECAME_UNION_MEMBER = `userJustBecameUnionMember`,
    DISPLAYED_WELCOME_UNION_MEMBER_DIALOG = `displayedWelcomeUnionMemberDialog`,
    USER_SESSION_KEY = `userSessionKey`,
    VISITED_PROFILE_UPDATE = `profileUpdate`,
    LAST_MENU_PAGE = `lastMenuPage`,
    PIXEL_ID = `pixelId`,
    BUNDLE = `bundle`,
    UNDERTAKING_FORM_IN_PROGRESS = `undertakingFormInProgress`,
    UNDERTAKING_FORM_SKIPPED = `undertakingFormSkipped`,
    UNDERTAKING_FORM_REFUND = `undertakingFormRefund`,
    UNDERTAKING_FORM_HAS_AGREED = `undertakingFormHasAgreed`,
    MYINFO_DATA = `myinfoData`,
}

export default LocalStorageKeys